import styled from "styled-components";
import { Form, Button } from "antd";
import { SiteOnBoardCardContent } from "../SiteOnboard/SiteOnboard.style";
// Custom card content without minimum height for login
export const LoginCardContent = styled(SiteOnBoardCardContent) `
  min-height: auto;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, 
      rgba(255, 255, 255, 0.8) 0%, 
      rgba(255, 255, 255, 0.4) 50%, 
      rgba(255, 255, 255, 0.8) 100%
    );
    border-radius: calc(15px * 4 / 3) calc(15px * 4 / 3) 0 0;
    z-index: 1;
  }
`;
export const LoginContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f8fafc;
  padding: 20px;
`;
export const LoginCard = styled.div `
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  padding: 48px;
  width: 100%;
  max-width: 420px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;
export const LoginHeader = styled.div `
  text-align: center;
  margin-bottom: 32px;
`;
export const LogoContainer = styled.div `
  margin-bottom: 16px;
  margin-top: 16px;
  display: flex;
  justify-content: center;
`;
export const LoginSubtitle = styled.p `
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
`;
export const LoginForm = styled(Form) `
  .ant-form-item-label > label {
    font-weight: 600;
    color: #374151;
    font-size: 14px;
    margin-bottom: 8px;
  }

  /* Remove conflicting input styles to let the filled variant work properly */
  .ant-input-affix-wrapper,
  .ant-input-password {
    /* Let the filled variant handle all styling */
  }

  .ant-input {
    font-size: 16px;
    
    &::placeholder {
      color: #9ca3af;
    }
  }

  .ant-input-prefix {
    margin-right: 12px;
    color: #6b7280;
  }
`;
export const FormItem = styled(Form.Item) `
  margin-bottom: 24px;

  .ant-form-item-explain-error {
    font-size: 13px;
    margin-top: 6px;
    color: #ef4444;
  }
`;
export const LoginButton = styled(Button) `
  height: 52px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 16px;
  background: ${({ theme }) => theme.colors.primary};
  border: none;
  transition: all 0.3s ease;
  margin-top: 8px;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryDark};
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(4, 180, 64, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &.ant-btn-loading {
    background: ${({ theme }) => theme.colors.primary};
  }

  &:not(.ant-btn-loading) {
    &:hover {
      border-color: transparent;
    }
  }
`;
export const ForgotPasswordLink = styled.div `
  text-align: center;
  margin-top: 8px;

  a {
    color: #3b82f6;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      color: #1d4ed8;
      text-decoration: underline;
    }
  }
`;
